import styles from "./index.module.scss";

const CalcFormRadioButton = ({
  label,
  id,
  defaultChecked = false,
  ...rest
}) => {
  return (
    <div className={styles.wrapper}>
      <input
        className={styles.input}
        defaultChecked={defaultChecked}
        type="radio"
        name="radio"
        id={id}
        {...rest}
      />
      <label
        className={styles.label}
        defaultChecked={defaultChecked}
        htmlFor={id}
      >
        {label}
      </label>
    </div>
  );
};

export default CalcFormRadioButton;
